<template>
  <div class="main-image-gen">
    <div class="mig-toolbar">
      <button class="scg-back-btn" @click="$emit('back')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        返回裂变图
      </button>
      <span class="scg-mode-tag">主图生成 (白底)</span>
      <button class="scg-generate-all-btn" @click="workbench.generateAllMainImages" :disabled="workbench.mainImageGen.loading">
        {{ workbench.mainImageGen.loading ? '生成中...' : '全部生成' }}
      </button>
      <button class="scg-download-page-btn" @click="downloadPageImages">下载全页图片</button>
      <button class="clear-task-btn" @click="onClearTask">清空任务</button>
    </div>

    <div v-for="item in activeProducts" :key="item.product.id" class="mig-product-section">
      <div class="mig-product-header">
        <span class="mig-product-name">{{ item.product.name }}</span>
        <button
          class="mig-download-zip-btn"
          :disabled="!hasAnyImage(item.pi)"
          @click="downloadZip(item.pi)"
        >下载全部</button>
        <button class="clear-product-btn" @click="workbench.clearProduct(item.pi)">清空</button>
      </div>

      <div class="mig-colors">
        <!-- Promo images -->
        <div v-for="sel in getPromoSlotsForProduct(item.pi)" :key="'p-' + sel.pi + '-' + sel.si" class="mig-color-row">
          <div class="mig-color-label">宣传图 {{ sel.si + 1 }}</div>
          <div class="mig-color-content">
            <div class="mig-source-area">
              <span class="mig-source-tag">原图</span>
              <div class="mig-source-img" v-if="workbench.getSelectedPromoImageForMain(sel.pi, sel.si)">
                <img :src="workbench.getSelectedPromoImageForMain(sel.pi, sel.si)" />
              </div>
            </div>
            <div class="mig-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </div>
            <div class="mig-result-area">
              <span class="mig-source-tag">白底主图</span>
              <div class="mig-result-slot" v-if="getResult(getPromoKey(sel.pi, sel.si))">
                <template v-if="getResult(getPromoKey(sel.pi, sel.si)).loading">
                  <div class="scg-loading-ring">
                    <svg viewBox="0 0 36 36">
                      <circle class="ring-bg" cx="18" cy="18" r="16" fill="none" stroke="#e5e6eb" stroke-width="3"/>
                      <circle class="ring-fg" cx="18" cy="18" r="16" fill="none" stroke="#165dff" stroke-width="3"
                        :stroke-dasharray="100" :stroke-dashoffset="100 - getResult(getPromoKey(sel.pi, sel.si)).progress" stroke-linecap="round"
                        transform="rotate(-90 18 18)"/>
                    </svg>
                    <span class="ring-text">{{ Math.round(getResult(getPromoKey(sel.pi, sel.si)).progress) }}%</span>
                  </div>
                </template>
                <template v-else-if="getResult(getPromoKey(sel.pi, sel.si)).url">
                  <img :src="getResult(getPromoKey(sel.pi, sel.si)).url" class="mig-result-img" @click="openMainLightbox(getResult(getPromoKey(sel.pi, sel.si)).url)" />
                  <div class="mig-result-actions">
                    <button class="scg-action-btn" title="裁剪" @click.stop="startMainCrop(getPromoKey(sel.pi, sel.si))">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"/>
                        <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn" title="重新生成" @click="genPromo(sel.pi, sel.si)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <polyline points="23 4 23 10 17 10"/>
                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn" title="下载" @click="downloadImage(getResult(getPromoKey(sel.pi, sel.si)).url, `main-promo-${sel.pi}-${sel.si}.png`)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                        <polyline points="7 10 12 15 17 10"/>
                        <line x1="12" y1="15" x2="12" y2="3"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn delete" title="删除" @click="workbench.clearMainImageResult(getPromoKey(sel.pi, sel.si))">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                      </svg>
                    </button>
                  </div>
                </template>
                <template v-else-if="getResult(getPromoKey(sel.pi, sel.si)).error">
                  <div class="mig-error">{{ getResult(getPromoKey(sel.pi, sel.si)).error }}</div>
                </template>
              </div>
              <div class="mig-result-empty" v-else>
                <button class="mig-gen-btn" @click="genPromo(sel.pi, sel.si)">生成</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Fission images -->
        <div v-for="(color, ci) in (workbench.imageGen.fissionColors[item.pi] || [])" :key="color.id" class="mig-color-row">
          <div class="mig-color-label">{{ color.label }}</div>
          <div class="mig-color-content">
            <div class="mig-source-area">
              <span class="mig-source-tag">原图</span>
              <div class="mig-source-img" v-if="workbench.getSelectedFissionImageForColor(item.pi, ci)">
                <img :src="workbench.getSelectedFissionImageForColor(item.pi, ci)" />
              </div>
              <div class="mig-source-empty" v-else>未选择</div>
            </div>
            <div class="mig-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </div>
            <div class="mig-result-area">
              <span class="mig-source-tag">白底主图</span>
              <div class="mig-result-slot" v-if="getResult(getFissionKey(item.pi, ci))">
                <template v-if="getResult(getFissionKey(item.pi, ci)).loading">
                  <div class="scg-loading-ring">
                    <svg viewBox="0 0 36 36">
                      <circle class="ring-bg" cx="18" cy="18" r="16" fill="none" stroke="#e5e6eb" stroke-width="3"/>
                      <circle class="ring-fg" cx="18" cy="18" r="16" fill="none" stroke="#165dff" stroke-width="3"
                        :stroke-dasharray="100" :stroke-dashoffset="100 - getResult(getFissionKey(item.pi, ci)).progress" stroke-linecap="round"
                        transform="rotate(-90 18 18)"/>
                    </svg>
                    <span class="ring-text">{{ Math.round(getResult(getFissionKey(item.pi, ci)).progress) }}%</span>
                  </div>
                </template>
                <template v-else-if="getResult(getFissionKey(item.pi, ci)).url">
                  <img :src="getResult(getFissionKey(item.pi, ci)).url" class="mig-result-img" @click="openMainLightbox(getResult(getFissionKey(item.pi, ci)).url)" />
                  <div class="mig-result-actions">
                    <button class="scg-action-btn" title="裁剪" @click.stop="startMainCrop(getFissionKey(item.pi, ci))">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"/>
                        <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn" title="重新生成" @click="genFission(item.pi, ci)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <polyline points="23 4 23 10 17 10"/>
                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn" title="下载" @click="downloadImage(getResult(getFissionKey(item.pi, ci)).url, `main-${workbench.products[item.pi]?.name}-${color.label}.png`)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                        <polyline points="7 10 12 15 17 10"/>
                        <line x1="12" y1="15" x2="12" y2="3"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn delete" title="删除" @click="workbench.clearMainImageResult(getFissionKey(item.pi, ci))">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                      </svg>
                    </button>
                  </div>
                </template>
                <template v-else-if="getResult(getFissionKey(item.pi, ci)).error">
                  <div class="mig-error">{{ getResult(getFissionKey(item.pi, ci)).error }}</div>
                </template>
              </div>
              <div class="mig-result-empty" v-else>
                <button class="mig-gen-btn" @click="genFission(item.pi, ci)" :disabled="!workbench.getSelectedFissionImageForColor(item.pi, ci)">
                  {{ workbench.getSelectedFissionImageForColor(item.pi, ci) ? '生成' : '未选图' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mig-product-section mig-extras-section">
      <div class="mig-product-header">
        <span class="mig-product-name">其他</span>
        <button class="mcf-upload-promo" @click="triggerExtraUpload" title="上传图片">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="17 8 12 3 7 8"/>
            <line x1="12" y1="3" x2="12" y2="15"/>
          </svg>
          <span>上传图片</span>
        </button>
        <button
          class="mig-download-zip-btn"
          :disabled="workbench.getExtrasAllImageUrls().length === 0"
          @click="downloadExtrasZip"
        >下载全部</button>
        <button class="clear-product-btn" @click="workbench.clearAllMainImageExtras()">清空</button>
      </div>

      <div v-if="workbench.mainImageExtras.length === 0" class="mig-extras-empty">
        点击"上传图片"添加自定义图片生成白底主图
      </div>

      <div v-else class="mig-colors">
        <div v-for="extra in workbench.mainImageExtras" :key="extra.id" class="mig-color-row">
          <div class="mig-color-label">
            其他图
            <button class="mig-extra-remove" title="移除该图" @click="workbench.removeMainImageExtra(extra.id)">&times;</button>
          </div>
          <div class="mig-color-content">
            <div class="mig-source-area">
              <span class="mig-source-tag">原图</span>
              <div class="mig-source-img">
                <img :src="extra.url" />
              </div>
            </div>
            <div class="mig-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </div>
            <div class="mig-result-area">
              <span class="mig-source-tag">白底主图</span>
              <div class="mig-result-slot" v-if="getResult(getExtraKey(extra.id))">
                <template v-if="getResult(getExtraKey(extra.id)).loading">
                  <div class="scg-loading-ring">
                    <svg viewBox="0 0 36 36">
                      <circle class="ring-bg" cx="18" cy="18" r="16" fill="none" stroke="#e5e6eb" stroke-width="3"/>
                      <circle class="ring-fg" cx="18" cy="18" r="16" fill="none" stroke="#165dff" stroke-width="3"
                        :stroke-dasharray="100" :stroke-dashoffset="100 - getResult(getExtraKey(extra.id)).progress" stroke-linecap="round"
                        transform="rotate(-90 18 18)"/>
                    </svg>
                    <span class="ring-text">{{ Math.round(getResult(getExtraKey(extra.id)).progress) }}%</span>
                  </div>
                </template>
                <template v-else-if="getResult(getExtraKey(extra.id)).url">
                  <img :src="getResult(getExtraKey(extra.id)).url" class="mig-result-img" @click="openMainLightbox(getResult(getExtraKey(extra.id)).url)" />
                  <div class="mig-result-actions">
                    <button class="scg-action-btn" title="裁剪" @click.stop="startMainCrop(getExtraKey(extra.id))">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"/>
                        <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn" title="重新生成" @click="workbench.generateOneMainImageExtra(extra.id)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <polyline points="23 4 23 10 17 10"/>
                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn" title="下载" @click="downloadImage(getResult(getExtraKey(extra.id)).url, `main-extra-${extra.id}.png`)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                        <polyline points="7 10 12 15 17 10"/>
                        <line x1="12" y1="15" x2="12" y2="3"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn delete" title="删除" @click="workbench.clearMainImageResult(getExtraKey(extra.id))">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                      </svg>
                    </button>
                  </div>
                </template>
                <template v-else-if="getResult(getExtraKey(extra.id)).error">
                  <div class="mig-error">{{ getResult(getExtraKey(extra.id)).error }}</div>
                </template>
              </div>
              <div class="mig-result-empty" v-else>
                <button class="mig-gen-btn" @click="workbench.generateOneMainImageExtra(extra.id)">生成</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ImageCropper
      :visible="cropState.visible"
      :imageSrc="cropState.imageSrc"
      @confirm="onCropConfirm"
      @cancel="onCropCancel"
      @restore="onCropRestore"
    />
  </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import ImageCropper from '@/components/common/ImageCropper.vue'

const workbench = useWorkbenchStore()

// eslint-disable-next-line no-undef
defineEmits(['back'])

const onClearTask = () => {
  if (!confirm('确定要清空当前任务吗？\n\n所有产品（A/B/C）的上传图片和所有生成结果都会被删除，且无法恢复。')) return
  workbench.clearAllTask()
}

const activeProducts = computed(() => {
  const promoPis = [...new Set(workbench.selectedPromoForMain.map(s => s.pi))]
  const fissionPis = [...new Set(workbench.selectedFissionImages.map(s => s.pi))]
  const allPis = [...new Set([...promoPis, ...fissionPis])]
  return allPis
    .map(i => ({ pi: i, product: workbench.products[i] }))
    .filter(item => item.product)
})

const getPromoSlotsForProduct = (pi) => workbench.selectedPromoForMain.filter(s => s.pi === pi)

const getPromoKey = (pi, si) => workbench.getMainImageKeyPromo(pi, si)
const getFissionKey = (pi, ci) => workbench.getMainImageKey(pi, ci)

const getResult = (key) => workbench.mainImageGen.results[key] || null

const genPromo = (pi, si) => {
  const url = workbench.getSelectedPromoImageForMain(pi, si)
  if (url) workbench.generateOneMainImage(getPromoKey(pi, si), url)
}

const genFission = (pi, ci) => {
  const url = workbench.getSelectedFissionImageForColor(pi, ci)
  if (url) workbench.generateOneMainImage(getFissionKey(pi, ci), url)
}

const openMainLightbox = (url) => {
  const urls = Object.values(workbench.mainImageGen.results).filter(r => r.url).map(r => r.url)
  workbench.openLightbox(url, urls)
}

const downloadImage = (url, filename) => {
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
}

const hasAnyImage = (pi) => workbench.getProductAllImageUrls(pi).length > 0

const downloadingPi = ref(-1)
const downloadZip = async (pi) => {
  downloadingPi.value = pi
  try {
    await workbench.downloadProductZip(pi)
  } catch (e) {
    alert('下载失败: ' + e.message)
  } finally {
    downloadingPi.value = -1
  }
}

const downloadPageImages = async () => {
  try {
    await workbench.downloadAllProductsZip()
  } catch (e) {
    alert('下载失败: ' + e.message)
  }
}

const getExtraKey = (id) => workbench.getMainImageKeyExtra(id)

const triggerExtraUpload = () => {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'
  input.onchange = async (e) => {
    const file = e.target.files?.[0]
    if (file) {
      try {
        await workbench.addMainImageExtra(file)
      } catch (err) {
        alert('上传失败: ' + (err?.message || '未知错误'))
      }
    }
  }
  input.click()
}

const downloadExtrasZip = async () => {
  try {
    await workbench.downloadExtrasZip()
  } catch (e) {
    alert('下载失败: ' + e.message)
  }
}

const cropState = reactive({ visible: false, imageSrc: '', key: '' })

const startMainCrop = (key) => {
  const slot = getResult(key)
  if (!slot?.url) return
  cropState.imageSrc = slot.url
  cropState.key = key
  cropState.visible = true
}

const onCropConfirm = (croppedBase64) => {
  workbench.applyCropResult('main', -1, cropState.key, croppedBase64)
  cropState.visible = false
}

const onCropRestore = () => {
  workbench.restoreOriginalImage('main', -1, cropState.key)
  cropState.visible = false
}

const onCropCancel = () => {
  cropState.visible = false
}
</script>

<style scoped>
.mig-download-zip-btn {
  margin-left: auto;
  padding: 6px 16px;
  background: #fff;
  color: var(--accent-amber);
  border: 1px solid var(--accent-amber);
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.mig-download-zip-btn:hover:not(:disabled) {
  background: var(--accent-amber);
  color: #fff;
}
.mig-download-zip-btn:disabled {
  background: #fff;
  color: #c9cdd4;
  border-color: #e5e6eb;
  cursor: not-allowed;
}
.mig-extras-section {
  margin-top: 16px;
  border-style: dashed;
}
.mig-extras-empty {
  padding: 24px;
  text-align: center;
  color: var(--text-sub, #86909c);
  font-size: 13px;
}
.mig-extra-remove {
  margin-left: 8px;
  width: 18px;
  height: 18px;
  border: 1px solid #f53f3f;
  background: #fff;
  color: #f53f3f;
  border-radius: 50%;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  vertical-align: middle;
  transition: all 0.15s;
}
.mig-extra-remove:hover {
  background: #f53f3f;
  color: #fff;
}
</style>
